import React, { createContext, useContext, useState, useEffect } from "react";
import AxiosInstance from "./AxiosInstance";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // localStorage n'est qu'un cache d'affichage (pré-remplissage optimiste) :
  // l'état de référence vient de l'API via GET /api/users/me (cookie httpOnly).
  const [user, setUser] = useState(() => {
    try {
      const storedUser = localStorage.getItem("user");
      return storedUser && storedUser !== "undefined" ? JSON.parse(storedUser) : null;
    } catch (e) {
      console.error("Erreur lors du parsing de l'utilisateur localStorage", e);
      return null;
    }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Nettoyer tout token legacy (le token vit désormais en cookie httpOnly)
    localStorage.removeItem("token");
    localStorage.removeItem("accessToken");

    let cancelled = false;

    AxiosInstance.get("/api/users/me")
      .then((res) => {
        if (cancelled) return;
        const apiUser = res.data?.user || res.data;
        setUser(apiUser || null);
        if (apiUser) {
          localStorage.setItem("user", JSON.stringify(apiUser));
        } else {
          localStorage.removeItem("user");
        }
      })
      .catch((err) => {
        if (cancelled) return;
        // 401 = session absente ou invalide : utilisateur non authentifié
        setUser(null);
        localStorage.removeItem("user");
        if (err.response?.status !== 401) {
          console.error("Erreur lors de la vérification de session :", err);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem("user", JSON.stringify(userData));
  };

  const logout = async () => {
    try {
      await AxiosInstance.post("/api/users/logout");
    } catch (err) {
      console.error("Erreur lors de la déconnexion côté serveur :", err);
    } finally {
      // Le nettoyage local doit se faire même si l'appel API échoue
      setUser(null);
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("accessToken");
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
